import { styledComponent } from '@hermes/web-components'

export const Container = styledComponent('div')`
  display: flex;
  width: 243px;
  flex-direction: column;
  gap: 8px;
  @media (max-width: 768px) {
    padding: 24px 0;
    border-top: 1px solid #D5DEF9;
    gap: 0px;
    width: 100%;
  }
  `

export const Title = styledComponent('h3')`
  color: #2A2461;
  font-weight: 700;
  font-size: 24px;
  text-align: start;
  line-height: 32px;
  margin: 0;
  @media (max-width: 768px) {
    margin: 0;
    line-height: 32px;
    font-size: 18px;
    font-weight: 500;
  }
  `

export const Subtitle = styledComponent('span')`
  color: #2A2461;
  font-weight: 400;
  font-size: 15px;
  text-align: start;
  line-height: 20px;
  `
